/**
 * Card Swatches - Image swap on hover/tap
 * Swaps product card thumbnail when hovering over color swatches
 */
(function() {
  'use strict';

  function initCardSwatches() {
    const swatchContainers = document.querySelectorAll('.card-swatches');

    swatchContainers.forEach(function(container) {
      const cardId = container.dataset.cardId;
      const swatches = container.querySelectorAll('.card-swatch');
      const image = document.querySelector('[data-card-image="' + cardId + '"]');

      if (!image || swatches.length === 0) return;

      swatches.forEach(function(swatch) {
        // Handle mouse hover
        swatch.addEventListener('mouseenter', function(e) {
          e.preventDefault();
          e.stopPropagation();
          swapImage(swatch, image, container);
        });

        // Handle click - prevent navigation
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          swapImage(swatch, image, container);
        });

        // Touch support
        swatch.addEventListener('touchstart', function(e) {
          e.preventDefault();
          e.stopPropagation();
          swapImage(swatch, image, container);
        }, { passive: false });

        // Also stop mousedown to prevent drag behavior
        swatch.addEventListener('mousedown', function(e) {
          e.stopPropagation();
        });
      });
    });
  }

  function swapImage(swatch, image, container) {
    const newSrc = swatch.dataset.variantImage;
    const newSrcset = swatch.dataset.variantSrcset;

    if (!newSrc) return;

    // Update image
    image.src = newSrc;
    if (newSrcset) {
      image.srcset = newSrcset;
    }

    // Update active state
    container.querySelectorAll('.card-swatch').forEach(function(s) {
      s.classList.remove('card-swatch--active');
    });
    swatch.classList.add('card-swatch--active');
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardSwatches);
  } else {
    initCardSwatches();
  }

  // Re-initialize when Shopify sections are loaded/updated (for AJAX pagination, etc.)
  document.addEventListener('shopify:section:load', initCardSwatches);

  // Also handle infinite scroll / AJAX loaded content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('.card-swatches')) {
            initCardSwatches();
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();